import { render, staticRenderFns } from "./compFunnel.vue?vue&type=template&id=239b2886&"
import script from "./compFunnel.vue?vue&type=script&lang=js&"
export * from "./compFunnel.vue?vue&type=script&lang=js&"
import style0 from "./compFunnel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports